<template>
    <div class="glass glass-card">
        <slot />
    </div>
</template>

<style scoped lang="scss">
.glass-card {
    padding: var(--site-space-lg);
}
</style>
